export const PASS_STYLES = {
  apple: {
    borderRadius: '8px',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15), 0 3px 8px rgba(0, 0, 0, 0.1)',
    qrPadding: 'p-1.5',
    qrRounding: 'rounded-sm',
  },
  google: {
    borderRadius: '14px',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.12)',
    qrPadding: 'px-1.5 py-1.5',
    qrRounding: 'rounded-lg',
    showDivider: true,
  }
} as const;

export const PASS_COLORS = {
  coupon: '#1e3a5f',
  loyalty: '#72461d',
} as const;

// Demo pass data for visualizations
export const DEMO_PASS_DATA = {
  coupon: {
    businessName: 'Café Milano',
    businessIcon: '☕',
    heroImageApple: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&h=150&fit=crop',
    heroImageGoogle: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=400&h=150&fit=crop',
    discountText: '15% OFF',
    discountSubtext: 'Your next visit',
    validUntil: 'Valid until Dec 31, 2025',
  },
  loyalty: {
    businessName: 'Café Milano',
    businessIcon: '☕',
    heroImageApple: 'https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=400&h=150&fit=crop',
    heroImageGoogle: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&h=150&fit=crop',
    currentStamps: 5,
    totalStamps: 8,
    rewardText: '3 more for free coffee',
  }
} as const;
